import { dashboard } from '../../../api';
import { call, takeLatest, put, delay } from 'redux-saga/effects';
import {
  GET_DASHBOARD_OVERVIEW,
  GET_DASHBOARD_OVERVIEW_START,
  GET_DASHBOARD_OVERVIEW_COMPLETE,
  GET_DASHBOARD_OVERVIEW_ERROR,
  GET_DASHBOARD_MISSED_SHIFT_DATA,
  GET_DASHBOARD_MISSED_SHIFT_DATA_START,
  GET_DASHBOARD_MISSED_SHIFT_DATA_COMPLETE,
  GET_DASHBOARD_MISSED_SHIFT_DATA_ERROR,
  GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA,
  GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_START,
  GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_COMPLETE,
  GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_ERROR,
  GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA,
  GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_START,
  GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_COMPLETE,
  GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_ERROR,
  GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA,
  GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_START,
  GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_COMPLETE,
  GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_ERROR,
  GET_DASHBOARD_TRAINING_GRAPH_DATA,
  GET_DASHBOARD_TRAINING_GRAPH_DATA_START,
  GET_DASHBOARD_TRAINING_GRAPH_DATA_COMPLETE,
  GET_DASHBOARD_TRAINING_GRAPH_DATA_ERROR,
  GET_DASHBOARD_AVG_TENURE_DATA,
  GET_DASHBOARD_AVG_TENURE_DATA_START,
  GET_DASHBOARD_AVG_TENURE_DATA_COMPLETE,
  GET_DASHBOARD_AVG_TENURE_DATA_ERROR,
  GET_DASHBOARD_GRAPH_OPTIONS,
  GET_DASHBOARD_GRAPH_OPTIONS_START,
  GET_DASHBOARD_GRAPH_OPTIONS_COMPLETE,
  GET_DASHBOARD_GRAPH_OPTIONS_ERROR,
  GET_CAREGIVER_INCENTIVE_UTILIZATION,
  GET_CAREGIVER_INCENTIVE_UTILIZATION_START,
  GET_CAREGIVER_INCENTIVE_UTILIZATION_COMPLETE,
  GET_CAREGIVER_INCENTIVE_UTILIZATION_ERROR,
  GET_TOP_FOUR_REWARDS,
  GET_TOP_FOUR_REWARDS_START,
  GET_TOP_FOUR_REWARDS_COMPLETE,
  GET_TOP_FOUR_REWARDS_ERROR,
  GET_CAREGIVER_INCENTIVES_BRANCH_LIST,
  GET_CAREGIVER_INCENTIVES_BRANCH_LIST_START,
  GET_CAREGIVER_INCENTIVES_BRANCH_LIST_COMPLETE,
  GET_CAREGIVER_INCENTIVES_BRANCH_LIST_ERROR,
  FETCH_AGENCIES_REQUEST,
  GET_SEND_CARE_COINS_ENABLED,
  GET_SEND_CARE_COINS_ENABLED_COMPLETE,
  FETCH_AGENCIES_REQUEST_START,
  FETCH_AGENCIES_REQUEST_COMPLETE,
  FETCH_AGENCIES_REQUEST_ERROR,
  GET_BALANCE_STATUS,
  GET_BALANCE_STATUS_START,
  GET_BALANCE_STATUS_COMPLETE,
  GET_BALANCE_STATUS_ERROR,
} from './actions';
import errorStrings from '../../../constants/errorStrings';
import { setUserStatusUnauthorised } from '../userProfile/actions';

export function* getDashboardOverview({ payload: { agency } }) {
  try {
    yield put({
      type: GET_DASHBOARD_OVERVIEW_START,
    });
    const { response, error } = yield call(dashboard.dashboardOverview, {
      agency,
    });

    if (!!response) {
      yield put({
        type: GET_DASHBOARD_OVERVIEW_COMPLETE,
        payload: { data: response.data[0] },
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onGetDashboardOverviewError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetDashboardOverviewError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* getDashboardMissedShiftRatioData({ payload: { agency } }) {
  try {
    yield put({
      type: GET_DASHBOARD_MISSED_SHIFT_DATA_START,
    });
    const { response, error } = yield call(dashboard.dashboardMissedShiftRatio, {
      agency,
    });

    if (!!response) {
      yield put({
        type: GET_DASHBOARD_MISSED_SHIFT_DATA_COMPLETE,
        payload: { data: response.data, missedShiftIndicator: response.legend },
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          getDashboardMissedShiftRatioDataError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      getDashboardMissedShiftRatioDataError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* getDashboardTotalValueEarnedData({ payload: { agency } }) {
  try {
    yield put({
      type: GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_START,
    });
    const { response, error } = yield call(dashboard.getDashboardTotalValueEarnedData, {
      agency,
    });

    if (!!response) {
      var branchNames = response.data.map(function (el) {
        return el.branch_name;
      });
      var newbranchNames = branchNames.map((branch) => ({
        label: branch,
        value: branch,
      }));
      yield put({
        type: GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_COMPLETE,
        payload: {
          data: response.data,
          branchName: newbranchNames,
          left_legend: response.left_legend,
          right_legend: response.right_legend,
        },
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onGetDashboardTotalValueEarnedDataError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetDashboardTotalValueEarnedDataError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* getDashboardLiveDailyTrackerData({ payload: { agency } }) {
  try {
    yield put({
      type: GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_START,
    });
    const { response, error } = yield call(dashboard.getDashboardLiveDailyTrackerData, {
      agency,
    });

    if (!!response) {
      yield put({
        type: GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_COMPLETE,
        payload: { data: response.data },
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onGetDashboardLiveDailyTrackerDataError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetDashboardLiveDailyTrackerDataError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* getDashboardProductivityScoreData({ payload: { agency } }) {
  try {
    yield put({
      type: GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_START,
    });
    const { response, error } = yield call(dashboard.getDashboardProductivityScoreData, {
      agency,
    });

    if (!!response) {
      yield put({
        type: GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_COMPLETE,
        payload: { data: response.data, productivityScoreIndicator: response.legend },
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onGetDashboardProductivityScoreDataError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetDashboardProductivityScoreDataError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* getDashboardTrainingGraphData({ payload: { agency } }) {
  try {
    yield put({
      type: GET_DASHBOARD_TRAINING_GRAPH_DATA_START,
    });
    const { response, error } = yield call(dashboard.getDashboardTrainingGraphData, {
      agency,
    });

    if (!!response) {
      yield put({
        type: GET_DASHBOARD_TRAINING_GRAPH_DATA_COMPLETE,
        payload: { data: response.data, traningGraphIndicator: response.legend },
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onGetDashboardTrainingGraphDataError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetDashboardTrainingGraphDataError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* getDashboardAvgTenureData({ payload: { agency } }) {
  try {
    yield put({
      type: GET_DASHBOARD_AVG_TENURE_DATA_START,
    });
    const { response, error } = yield call(dashboard.getDashboardAvgTenureData, {
      agency,
    });

    if (!!response) {
      yield put({
        type: GET_DASHBOARD_AVG_TENURE_DATA_COMPLETE,
        payload: { data: response.data, avgTenureIndicator: response.legend },
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onGetDashboardAvgTenureDataError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetDashboardAvgTenureDataError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* getDashboardGraphOptions({ payload: { agency } }) {
  try {
    yield put({
      type: GET_DASHBOARD_GRAPH_OPTIONS_START,
    });
    const { response, error } = yield call(dashboard.getDashboardGraphOptions, {
      agency,
    });

    if (!!response) {
      var index = response.data.indexOf('PRODUCTIVITY');
      var data = response.data;
      if (index !== -1) {
        data.sort((a, b) => {
          if (a === 'PRODUCTIVITY') return -1;
          if (b === 'PRODUCTIVITY') return 1;
          return 0;
        });
      }
      yield put({
        type: GET_DASHBOARD_GRAPH_OPTIONS_COMPLETE,
        payload: { data: data },
      });
    } else {
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        yield put(
          onGetDashboardGraphOptionsError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetDashboardGraphOptionsError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* getCaregiverIncentiveUtilization({
  payload: { fromDate, toDate, branchName,agency },
}) {
  try {
    yield put({
      type: GET_CAREGIVER_INCENTIVE_UTILIZATION_START,
    });
    const { response, error } = yield call(dashboard.getCaregiverIncentiveUtilization, {
      fromDate,
      toDate,
      branchName,
      agency,
    });

    if (!!response) {
      yield put({
        type: GET_CAREGIVER_INCENTIVE_UTILIZATION_COMPLETE,
        payload: {
          data: response.data,
          legend: response.left_legend,
        },
      });
    } else {
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        yield put(
          onGetCaregiverIncentiveUtilizationError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetCaregiverIncentiveUtilizationError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* getCaregiverIncentiesBranchList({payload: { agency }}) {
  try {
    yield put({
      type: GET_CAREGIVER_INCENTIVES_BRANCH_LIST_START,
    });
    const { response, error } = yield call(dashboard.getCaregiverIncentiesBranchList, {
      agency,
      });

    if (!!response) {
      var branchNames = response.data.branch_list;
      var newbranchNames = branchNames.map((branch) => ({
        label: branch,
        value: branch,
      }));
      yield put({
        type: GET_CAREGIVER_INCENTIVES_BRANCH_LIST_COMPLETE,
        payload: { data: newbranchNames },
      });
    } else {
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        yield put(
          onGetCaregiverIncentiesBranchListError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetCaregiverIncentiesBranchListError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* getTopFourRewards({payload: { agency }}) {
  try {
    yield put({
      type: GET_TOP_FOUR_REWARDS_START,
    });
    const { response, error } = yield call(dashboard.getTopFourRewards, {
      agency,
      });

    if (!!response) {
      yield put({
        type: GET_TOP_FOUR_REWARDS_COMPLETE,
        payload: { data: response.data },
      });
    } else {
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        yield put(
          onGetTopFourRewardsError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetTopFourRewardsError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* fetchAgenciesList() {
  try {
    yield put({
      type: FETCH_AGENCIES_REQUEST_START,
    });
    const { response, error } = yield call(dashboard.getAgencyList);

    if (!!response) {
      const agencies = response.data.map((agency) => ({
        value: agency,
        label: agency,
      }));
      yield put({
        type: FETCH_AGENCIES_REQUEST_COMPLETE,
        payload: agencies,
      });
    } else {
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        yield put(
          fetchAgenciesError({
            error: error?.data?.message || errorStrings.commonError,
          })
        );
      }
    }
  } catch (error) {
    yield put(fetchAgenciesError({ error: errorStrings.commonError }));
  }
}

export function* getBalanceStatus({ payload: { agency } }) {
  try {
    yield put({
      type: GET_BALANCE_STATUS_START,
    });
    const { response, error } = yield call(dashboard.getBalanceStatus, {
      agency,
    });

    // const response = {
    //   data: {
    //     balance_status: 'low_balance',
    //     message: 'Warning: Tango balance is running low! Required: $300, Available: $200',
    //   }
    // };
    // const error = '';

    if (!!response) {
      yield put({
        type: GET_BALANCE_STATUS_COMPLETE,
        payload: { data: response.data },
      });
    } else {
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        yield put(
          onGetBalanceStatusError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetBalanceStatusError({
        error: errorStrings.commonError,
      }),
    );
  }
}

const onGetBalanceStatusError = (payload = {}) => ({
  type: GET_BALANCE_STATUS_ERROR,
  payload,
});

const onGetCaregiverIncentiesBranchListError = (payload = {}) => ({
  type: GET_CAREGIVER_INCENTIVES_BRANCH_LIST_ERROR,
  payload,
});

const onGetTopFourRewardsError = (payload = {}) => ({
  type: GET_TOP_FOUR_REWARDS_ERROR,
  payload,
});

const onGetCaregiverIncentiveUtilizationError = (payload = {}) => ({
  type: GET_CAREGIVER_INCENTIVE_UTILIZATION_ERROR,
  payload,
});

const onGetDashboardGraphOptionsError = (payload = {}) => ({
  type: GET_DASHBOARD_GRAPH_OPTIONS_ERROR,
  payload,
});

const onGetDashboardProductivityScoreDataError = (payload = {}) => ({
  type: GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_ERROR,
  payload,
});

const onGetDashboardTrainingGraphDataError = (payload = {}) => ({
  type: GET_DASHBOARD_TRAINING_GRAPH_DATA_ERROR,
  payload,
});

const onGetDashboardAvgTenureDataError = (payload = {}) => ({
  type: GET_DASHBOARD_AVG_TENURE_DATA_ERROR,
  payload,
});

const onGetDashboardLiveDailyTrackerDataError = (payload = {}) => ({
  type: GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_ERROR,
  payload,
});

const onGetDashboardTotalValueEarnedDataError = (payload = {}) => ({
  type: GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_ERROR,
  payload,
});

const getDashboardMissedShiftRatioDataError = (payload = {}) => ({
  type: GET_DASHBOARD_MISSED_SHIFT_DATA_ERROR,
  payload,
});

const onGetDashboardOverviewError = (payload = {}) => ({
  type: GET_DASHBOARD_OVERVIEW_ERROR,
  payload,
});

const fetchAgenciesError = (payload = {}) => ({
  type: FETCH_AGENCIES_REQUEST_ERROR,
  payload,
});

function* watchGetBalanceStatus() {
  yield takeLatest(GET_BALANCE_STATUS, getBalanceStatus);
}

function* watchGetDashboardLiveDailyTrackerData() {
  yield takeLatest(
    GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA,
    getDashboardLiveDailyTrackerData,
  );
}

function* watchGetDashboardTotalValueEarnedData() {
  yield takeLatest(
    GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA,
    getDashboardTotalValueEarnedData,
  );
}

function* watchGetDashboardGraphOptions() {
  yield takeLatest(GET_DASHBOARD_GRAPH_OPTIONS, getDashboardGraphOptions);
}

function* watchGetDashboardOverview() {
  yield takeLatest(GET_DASHBOARD_OVERVIEW, getDashboardOverview);
}
function* watchGetDashboardMissedShiftRatioData() {
  yield takeLatest(GET_DASHBOARD_MISSED_SHIFT_DATA, getDashboardMissedShiftRatioData);
}

function* watchGetDashboardProductivityScoreData() {
  yield takeLatest(
    GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA,
    getDashboardProductivityScoreData,
  );
}

function* watchGetDashboardTrainingGraphData() {
  yield takeLatest(GET_DASHBOARD_TRAINING_GRAPH_DATA, getDashboardTrainingGraphData);
}

function* watchGetDashboardAvgTenureData() {
  yield takeLatest(GET_DASHBOARD_AVG_TENURE_DATA, getDashboardAvgTenureData);
}

function* watchGetCaregiverIncentiveUtilization() {
  yield takeLatest(GET_CAREGIVER_INCENTIVE_UTILIZATION, getCaregiverIncentiveUtilization);
}

function* watchGetTopFourRewards() {
  yield takeLatest(GET_TOP_FOUR_REWARDS, getTopFourRewards);
}

function* watchGetCaregiverIncentiesBranchList() {
  yield takeLatest(GET_CAREGIVER_INCENTIVES_BRANCH_LIST, getCaregiverIncentiesBranchList);
}
export function* getSendCareCoinsEnabled() {
  try {
    const { response } = yield call(dashboard.getSendCareCoinsEnabled);
    // Fail closed -- any error leaves the button hidden rather than offering
    // one the add-care-coins API would reject.
    yield put({
      type: GET_SEND_CARE_COINS_ENABLED_COMPLETE,
      payload: !!response?.data?.isSendCareCoinsEnabled,
    });
  } catch (error) {
    yield put({
      type: GET_SEND_CARE_COINS_ENABLED_COMPLETE,
      payload: false,
    });
  }
}

function* watchFetchAgencies() {
  yield takeLatest(FETCH_AGENCIES_REQUEST, fetchAgenciesList);
  }

function* watchGetSendCareCoinsEnabled() {
  yield takeLatest(GET_SEND_CARE_COINS_ENABLED, getSendCareCoinsEnabled);
}

export const sagas = [
  watchGetDashboardOverview,
  watchGetDashboardMissedShiftRatioData,
  watchGetDashboardLiveDailyTrackerData,
  watchGetDashboardTotalValueEarnedData,
  watchGetDashboardProductivityScoreData,
  watchGetDashboardTrainingGraphData,
  watchGetDashboardAvgTenureData,
  watchGetDashboardGraphOptions,
  watchGetCaregiverIncentiveUtilization,
  watchGetTopFourRewards,
  watchGetCaregiverIncentiesBranchList,
  watchFetchAgencies,
  watchGetSendCareCoinsEnabled,
  watchGetBalanceStatus,
];
